export function hasWeb3Extension(): boolean {
    return typeof window.ethereum !== 'undefined';
}
